export default "__VITE_ASSET__yExXFG_y__"